import { IonContent, useIonViewWillLeave, IonButtons, IonButton, IonSearchbar, IonModal, IonFab, IonFabButton, IonFabList, IonLabel, IonInput, IonItemOption, IonItemOptions, IonItemSliding, IonBackButton, IonList, IonItem, IonHeader, IonPage, IonTitle, IonToolbar, IonGrid, IonRow, IonCol, IonCard, IonCardHeader, IonCardTitle, IonCardContent, IonIcon, useIonAlert, IonImg, IonTextarea, IonSpinner } from '@ionic/react';
import { add, searchOutline, barcodeOutline, closeOutline } from 'ionicons/icons';
import './purchase.css';
import { people } from 'ionicons/icons'
import axios from "axios";
import getApi from '../../api';
import EnvironmentBadge from '../../components/EnvironmentBadge';
import { useParams } from 'react-router';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useIonViewDidEnter, useIonRouter } from '@ionic/react';
import { useLocalStorage } from '../../components/useLocalStorage';
import { useScannerBridge } from '../../hooks/useScannerBridge';
import { DataGrid, GridActionsCellItem, GridCellModes, GridCellModesModel, GridCellParams, GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { Box } from '@mui/material';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import {Html5Qrcode} from "html5-qrcode";

interface Article {
    Description: string;
    ArticleNumber: string;
    OrderedQuantity: number;
}

interface Picture {
  path: string;
}

interface ArtInfo {
  id: string;
  name: string;
  accounting_connector: string;
  quantity: string;
  pictures: Picture[];
  arriving_sum: string;
}

const Purchase: React.FC = () => {
    let [articles, setarticles] = useState<Article[]>([]);
    const [presentAlert] = useIonAlert();
    const [showModal, setShowModal] = useState(false);
    const [showInfoModal, setShowInfoModal] = useState(false);
    let [products, setProducts] = useState([]);
    let [qty, setqty] = useState("");
    let [artinfo, setartinfo] = useState<ArtInfo | null>(null);
    const modal = useRef<HTMLIonModalElement>(null);
    const contentRef = useRef<HTMLIonContentElement>(null); // Ref for the modal's content
    const inputRef = useRef<HTMLIonInputElement>(null); // Ref for the input
    const [comments, setComments] = useState("");
    const [scannerActive, setScannerActive] = useState(false);
    const [scannerLoading, setScannerLoading] = useState(false);

  const api = getApi();

            
    function addArticle(name: any, accounting_connector: any, quantity?: number) {
    
        let existingArticle = articles.find((row: any) => row.ArticleNumber === accounting_connector);
    
        if (existingArticle) {
          console.log("Qty: "+quantity)
            // If quantity is 0 remove the article
            if (Number(quantity) === 0) {
              setarticles(articles.filter((row: any) => row.ArticleNumber !== accounting_connector));
              return;
            }
          else if (quantity) {
            (existingArticle as Article).OrderedQuantity = Number(quantity);
          }
          else {
          (existingArticle as Article).OrderedQuantity += 1;
          }
        } else {
            let art = {
                Description: name,
                ArticleNumber: accounting_connector,
                OrderedQuantity: 1.00,
            }
            setarticles([...articles, art]);

        }
        setShowModal(false);
    }


    function updateArticle(name: any, accounting_connector: any, quantity: any) {
      setqty(quantity)
      addArticle(name, accounting_connector, quantity)
      setqty("")
      setartinfo(null)
      setShowInfoModal(false);
    }

    function articleinfo(art: any, qty: any) {
      setqty(qty)
      api.get("/api/bbe/articles/?accounting_connector="+art)
          .then(res => {
            console.log(res.data)
            if(res.data.count == 1){
              setartinfo(res.data.results[0])
            } else {
              presentAlert({
                message: 'Fel vid inläsningen av artikeln!',
                buttons: ['OK'],
              })
            }
          })
        setShowInfoModal(true);
    }

        const [barcodeRead, setBarcodeRead] = useState("");
    
        if (barcodeRead.length > 0) {
    
          api.get("/api/bbe/articles/?accounting_connector="+barcodeRead)
          .then(res => {
            console.log(res.data)
            if(res.data.count == 1){
              // If res.data.results[0].arriving_sum is not 0 prompt the user to ask if they want to add the article
              if(res.data.results[0].arriving_sum != 0) {
                presentAlert({
                  message: 'Det finns '+res.data.results[0].arriving_sum+'st '+res.data.results[0].name+' på väg in. Vill du lägga till artikeln?',
                  buttons: [
                    {
                      text: 'Ja',
                      handler: () => {
                        addArticle(res.data.results[0].name, res.data.results[0].accounting_connector)
                      }
                    },
                    {
                      text: 'Nej',
                      handler: () => {
                        setBarcodeRead(""); 
                      }
                    }
                  ],
                })
              } else {
              addArticle(res.data.results[0].name, res.data.results[0].accounting_connector)
            }
            } else {
              presentAlert({
                message: 'Det finns ingen artikel med artikelnumret: '+barcodeRead,
                buttons: ['OK'],
              })
            }
          })
    
          setBarcodeRead(""); 
    
        }
         
      
        const barcode = {
          timing: 1000,
          data: "",
        };
      
        const barcodeReaded = () => {
          if (barcode.data.length > 5) {
            setBarcodeRead(barcode.data);
    
          } else {
            barcode.data = "";
          }
        };
      
        let timeout = setTimeout(barcodeReaded, 500);
      
        useEffect(() => {
          window.addEventListener("keypress", (e) => {
            console.log(e.key);
            console.log(e.timeStamp);
            if (barcode.data.length === 0 || e.timeStamp - barcode.timing < 200) {
              if (e.key === "Enter") {
                barcodeReaded();
                barcode.data = ""; // Reset barcode data
                barcode.timing = 1000; // Reset barcode timing
                return
              } else {
              barcode.data += e.key;
              barcode.timing = e.timeStamp;
              clearTimeout(timeout);
              timeout = setTimeout(barcodeReaded, 500);
              }
            } else {
              barcode.data = "";
            }
            console.log(barcode);
          });

          api.get("/api/bbe/articles/")
          .then(res => {
            console.log(res.data)
            setProducts(res.data.results)
          })
        }, []);

        const handleScan = useCallback((code: string) => {
          if (!code || scannerLoading) return;
          
          // Close modal but keep camera running for next scan
          setScannerActive(false);
          setScannerLoading(false);
          
          const trimmed = code.trim();
          console.log('Scanned code:', trimmed);
          
          api.get("/api/bbe/articles/?accounting_connector=" + trimmed)
            .then(res => {
              console.log(res.data);
              if (res.data.count == 1) {
                // If res.data.results[0].arriving_sum is not 0 prompt the user to ask if they want to add the article
                if (res.data.results[0].arriving_sum != 0) {
                  presentAlert({
                    message: 'Det finns ' + res.data.results[0].arriving_sum + 'st ' + res.data.results[0].name + ' på väg in. Vill du lägga till artikeln?',
                    buttons: [
                      {
                        text: 'Ja',
                        handler: () => {
                          addArticle(res.data.results[0].name, res.data.results[0].accounting_connector);
                        }
                      },
                      {
                        text: 'Nej',
                        handler: () => {
                          // Do nothing
                        }
                      }
                    ],
                  });
                } else {
                  addArticle(res.data.results[0].name, res.data.results[0].accounting_connector);
                }
              } else {
                presentAlert({
                  message: 'Det finns ingen artikel med det artikelnumret!',
                  buttons: ['OK'],
                });
              }
            })
            .catch(err => {
              console.error('Failed to fetch article:', err);
              presentAlert({
                message: 'Kunde inte hämta artikelinformation',
                buttons: ['OK'],
              });
            });
        }, [scannerLoading, api, presentAlert]);

        const { startScanner, stopScanner } = useScannerBridge({ autoStart: false, onScan: handleScan });

        const handleActivateScanner = async () => {
          if (scannerLoading || scannerActive) return;
          
          // Show modal immediately for instant feedback
          setScannerActive(true);
          setScannerLoading(true);
          
          // Start scanner in background
          try {
            await startScanner();
            setScannerLoading(false);
          } catch (error) {
            console.error('Failed to start scanner:', error);
            setScannerActive(false);
            setScannerLoading(false);
            presentAlert({
              header: 'Fel',
              message: 'Kunde inte starta skannern. Kontrollera behörigheter.',
              buttons: ['OK']
            });
          }
        };

        const handleStopScanner = () => {
          stopScanner();
          setScannerActive(false);
          setScannerLoading(false);
        };

        useIonViewWillLeave(() => {
          if (scannerActive) {
            stopScanner();
            setScannerActive(false);
          }
        });
        
          function getRowId(row: { RowId?: any; }) {
            return row.RowId
        }

        const handleChange = (ev: Event) => {
          let query = "";
          const target = ev.target as HTMLIonSearchbarElement;
          if (target) query = target.value!.toLowerCase();
      
            api.get("/api/bbe/articles/?search="+query)
              .then(res => {
                console.log(res.data.Customers)
                setProducts(res.data.results)
              })
      
          console.log(query);
        }

        function sendpurchaseorder() {

          let data = [{"PurchaseOrder": articles}]
          console.log(data)

          api.post('/fortnox/purchaseorder/', {
            data: JSON.stringify(data),
            comments: comments
          })
          .then(function (response) {
            console.log(response);
            setComments("")
            setarticles([])
            presentAlert({
              message: "Beställningen skickades!",
              buttons: ['OK'],
            })
          })
          .catch(function (error) {
            console.log(error.response.data);

            presentAlert({
              message: error.response.data,
              buttons: ['OK'],
            })
          });
        }

        function manualadd(name: any, accounting_connector: any, arriving_sum: any) {
          if(arriving_sum != 0) {
            presentAlert({
              message: 'Det finns '+arriving_sum+'st '+name+' på väg in. Vill du lägga till artikeln?',
              buttons: [
                {
                  text: 'Ja',
                  handler: () => {
                    addArticle(name, accounting_connector)
                  }
                },
                {
                  text: 'Nej',
                  handler: () => {
                    setBarcodeRead(""); 
                  }
                }
              ],
            })
          } else {
            addArticle(name, accounting_connector)
        }
        }

        

  return (
    <IonPage placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
      <IonHeader placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
        <IonToolbar color="primary" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <IonButtons slot="start" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            {scannerActive ? (
              <IonButton onClick={handleStopScanner} color="danger" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <IonIcon slot="icon-only" icon={closeOutline} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
              </IonButton>
            ) : (
              <IonBackButton />
            )}
          </IonButtons>
          <IonTitle placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            {scannerActive ? 'Skanna streckkod' : 'Skapa inköp'}
          </IonTitle>
          <div slot="end" style={{paddingRight:'8px'}}><EnvironmentBadge /></div>
        </IonToolbar>
        {!scannerActive && (
          <>
            <IonItem placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonLabel position="floating" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Kommentar:</IonLabel>
              <IonTextarea value={comments} onIonChange={e => setComments(e.detail.value!)} placeholder="Enter comments" onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} autoGrow={true}></IonTextarea>
            </IonItem>
            <IonButton size="large" color="success" onClick={sendpurchaseorder} expand="block" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Skicka Beställning</IonButton>
            <IonRow className='row header' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonCol size="3" className='col' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Art.nr</IonCol>
            <IonCol size="2" className='col' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Antal</IonCol>
            <IonCol className='col' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Namn</IonCol>
        </IonRow>
          </>
        )}
      </IonHeader>
      <IonContent ref={contentRef} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
        <div 
          id="data-capture-view" 
          style={{ position: 'fixed', inset: 0, zIndex: 20, pointerEvents: 'none', display: scannerActive ? 'block' : 'none' }} 
        />
        
        {/* Loading overlay när skannern startar */}
        {scannerActive && scannerLoading && (
          <div style={{
            position: 'fixed',
            inset: 0,
            zIndex: 21,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            pointerEvents: 'none'
          }}>
            <div style={{ textAlign: 'center', color: 'white' }}>
              <IonSpinner name="crescent" style={{ width: '48px', height: '48px' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
              <div style={{ marginTop: '16px', fontSize: '16px' }}>Startar kamera...</div>
            </div>
          </div>
        )}
      
        { articles.map(art => (
          <IonRow onClick={() => articleinfo(art['ArticleNumber'], art['OrderedQuantity'])} className='row' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonCol size="3" className='col' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{ art['ArticleNumber'] }</IonCol>
            <IonCol size="2" className='col' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{ art['OrderedQuantity'] }</IonCol>
            <IonCol className='col' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{ art['Description'] }</IonCol>
        </IonRow>
        ))}
        
        <IonFab slot="fixed" vertical="bottom" horizontal="end" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <IonFabButton onClick={() => setShowModal(false)} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonIcon icon={add} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon>
          </IonFabButton>
          <IonFabList side="top" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonFabButton onClick={() => setShowModal(true)} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonIcon icon={searchOutline} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon>
            </IonFabButton>
            <IonFabButton onClick={scannerActive ? handleStopScanner : handleActivateScanner} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonIcon icon={barcodeOutline} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon>
            </IonFabButton>
          </IonFabList>
        </IonFab>

        <IonModal isOpen={showModal} ref={modal} trigger="open-modal" initialBreakpoint={1} breakpoints={[0, 1]} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <IonContent className="ion-padding" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonSearchbar placeholder="Sök" debounce={500} onIonChange={(ev) => handleChange(ev)} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonSearchbar>
            <IonList placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              
              { products.map((result: any) => (
                <IonItem onClick={() => manualadd(result["name"], result["accounting_connector"], result["arriving_sum"])} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  <h2> { result["name"] } </h2>
                  <p>{ result["sale_price"] }</p>
                </IonLabel>
              </IonItem>
              ))}
            </IonList>
          </IonContent>
        </IonModal>

        <IonModal isOpen={showInfoModal} trigger="open-modal" initialBreakpoint={1} breakpoints={[1]} backdropDismiss={true} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <IonContent ref={contentRef} className="ion-padding botom-padding" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          
          <IonGrid placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonCol size="12" size-sm="6" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonList placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <IonItem placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Artikelnummer:</IonCol>
                    <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}> {artinfo?.accounting_connector} </IonCol>
                  </IonRow>
                </IonItem>
                
                <IonItem placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonCol size="3" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Namn:</IonCol>
                    <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}> {artinfo?.name} </IonCol>
                  </IonRow>
                </IonItem>

                <IonItem placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonCol size="auto" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>I lager:</IonCol>
                    <IonCol size="auto" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}> <span>{Number(artinfo?.quantity)} </span></IonCol>
                  </IonRow>
                </IonItem>

                <IonItem placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonCol size="auto" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>På väg in:</IonCol>
                    <IonCol size="auto" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}> <span>{Number(artinfo?.arriving_sum)} </span></IonCol>
                  </IonRow>
                </IonItem>

                <IonItem placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <IonCol size="5" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Beställ antal:</IonCol>
                <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}> <IonInput ref={inputRef} type="number" onIonChange={(e) => setqty(e.detail.value!)} value={qty} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonInput></IonCol>
                </IonItem>
                <IonImg
                    src={artinfo?.pictures[0]?.path || "https://butik.bbe.nu/assets/images/no-product-image.jpg"}
                    alt="Ingen bild :)" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} ></IonImg>
              </IonList>
              </IonCol>
            </IonRow>
            <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}><IonButton size="large" color="danger" onClick={() => updateArticle(artinfo?.name, artinfo?.accounting_connector, 0)} expand="block" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Ta bort artikel</IonButton></IonCol>
            </IonRow>
            <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}><IonButton size="large" color="success" onClick={() => updateArticle(artinfo?.name, artinfo?.accounting_connector, qty)} expand="block" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Spara</IonButton></IonCol>
            </IonRow>
          </IonGrid>
            
          </IonContent>
        </IonModal>
      </IonContent>
    </IonPage>
  );
};

export default Purchase;